import React from "react";
import resumeFile from "../documents/resume1.pdf";
const AboutUs = ({ classicHeader, darkTheme }) => {
  return (
    <section id="about" className={"section " + (darkTheme ? "bg-dark-1" : "")}>
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            About Me
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            Know Me More
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gy-5">
          {/* About me content start */}
          <div className="col-lg-7 col-xl-8 text-center text-lg-start">
            <h2
              className={
                "text-7 fw-600 mb-3 " + (darkTheme ? "text-white" : "")
              }
            >
              I'm <span className="text-primary">Shewatsehay Tekese,</span> a
              Full-Stack Web Developer
            </h2>
            <p className={darkTheme ? "text-white-50" : ""}>
              I'm a passionate Full-Stack Web Developer with a strong foundation
              in modern web technologies. I build responsive, scalable, and
              user-friendly web applications — from intuitive front-end
              interfaces to powerful back-end systems.
            </p>
            <p className={darkTheme ? "text-white-50" : ""}>
              I specialize in turning ideas into fully functional digital
              solutions. With hands-on experience in technologies like React,
              Node.js, Express, and MongoDB, I love crafting clean code and
              delivering seamless user experiences. Beyond development, I also
              offer creative services such as video editing and graphic design
              using Adobe Photoshop. My focus is always on writing maintainable
              code, meeting deadlines, and exceeding client expectations with
              both technical and visual excellence.
            </p>
            <p className={darkTheme ? "text-white-50" : ""}>
              Let’s bring your vision to life — whether it's a portfolio, a web
              app, or a custom business solution.
            </p>
          </div>
          {/* About me content end */}

          {/* About me personal details start */}
          <div className="col-lg-5 col-xl-4">
            <div className="ps-lg-4">
              <ul
                className={
                  "list-style-2 " +
                  (darkTheme ? "list-style-light text-light" : "")
                }
              >
                <li>
                  <span className="fw-600 me-2">Name:</span>Shewatsehay Getiye
                </li>
                <li>
                  <span className="fw-600 me-2">Email:</span>
                  <a href="yetsehay21@gmail.com">yetsehay21@gmail.com</a>
                </li>
                <li>
                  <span className="fw-600 me-2">Role:</span>Full-Stack Developer
                </li>
                <li className="border-0">
                  <span className="fw-600 me-2">From:</span>Virginia, USA
                </li>
              </ul>
              <a
                href={resumeFile}
                download
                className="btn btn-primary rounded-pill"
              >
                Download CV
              </a>
            </div>
          </div>
          {/* About me personal details end */}
        </div>

        {/* projects rewards counting start */}
        <div
          className={
            "brands-grid separator-border mt-5 " +
            (darkTheme ? "separator-border-light" : "")
          }
        >
          {/* <div className="row">
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>10</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Years Experiance
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>250</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Happy Clients
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>650</span>+
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Projects Done
                </p>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <div className="featured-box text-center">
                <h4
                  className={
                    "text-12  mb-0 " +
                    (darkTheme ? "text-white-50" : "text-muted")
                  }
                >
                  <span>38</span>
                </h4>
                <p className={"mb-0 " + (darkTheme ? "text-light" : "")}>
                  Get Awards
                </p>
              </div>
            </div>
          </div> */}
        </div>
        {/* projects rewards counting end */}
      </div>
    </section>
  );
};

export default AboutUs;
